import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import ErrorBoundary from 'flow-doctor-lib/components/common/ErrorBoundary';
import UIWizardStep from 'UIComponents/dialog/UIWizardStep';
import UIWizard from 'UIComponents/dialog/UIWizard';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import ChooseObjectAndTimelineItemStep from 'flow-doctor-lib/components/diagnosis/non-enrollment/ChooseObjectAndTimelineItemStep';
import TimelineItemDiagnosisStep from 'flow-doctor-lib/components/diagnosis/non-enrollment/TimelineItemDiagnosisStep';
import CrmObjectSelect from 'flow-doctor-lib/components/common/CrmObjectSelect';
import useQueryParams, { nanNumberMapper } from 'flow-doctor-lib/hooks/useQueryParams';
import useUpdateQueryParams from 'flow-doctor-lib/hooks/useUpdateQueryParams';
import { makeTimelineItemUuid } from 'flow-doctor-lib/utils/timelineItemUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NonEnrollmentDiagnosisPanel = ({
  width,
  flowId,
  objectTypeId,
  onClose,
  CrmObjectSelectComponent = CrmObjectSelect
}) => {
  const updateQueryParams = useUpdateQueryParams();
  const {
    objectId
  } = useQueryParams({
    objectId: nanNumberMapper
  });
  const [selectedTimelineItem, setSelectedTimelineItem] = React.useState();
  const [stepIndex, setStepIndex] = React.useState(0);
  const onSelectTimelineItem = logItem => {
    updateQueryParams({
      timelineItem: makeTimelineItemUuid(logItem)
    });
    setSelectedTimelineItem(logItem);
    setStepIndex(1);
  };
  return /*#__PURE__*/_jsx(UIModalPanel, {
    width: width,
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      boundaryName: "NON_ENROLLMENT_DIAGNOSIS_PANEL",
      renderError: () => /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "badRequest",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.global.errorBoundary.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.global.errorBoundary.nonEnrollmentDescription"
        })
      }),
      children: /*#__PURE__*/_jsxs(UIWizard, {
        stepIndex: stepIndex,
        defaultHeading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.troubleshootEnrollment"
        }),
        onReject: onClose,
        onConfirm: onClose
        // Hide the footer on the first step
        ,
        footerComponent: stepIndex === 0 ? () => null : undefined,
        onStepIndexChange: ({
          target: {
            value
          }
        }) => {
          // Should only allow users to go back to the initial step. Ignore any other indices and log them
          if (value !== 0) {
            console.error(`Attempted to navigate to invalid step ${value} in non-enrollment wizard`);
          } else {
            updateQueryParams({}, ['timelineItem']);
            setStepIndex(value);
          }
        },
        children: [/*#__PURE__*/_jsx(UIWizardStep, {
          children: /*#__PURE__*/_jsx(ChooseObjectAndTimelineItemStep, {
            flowId: flowId,
            objectId: objectId,
            objectTypeId: objectTypeId,
            setSelectedTimelineItem: onSelectTimelineItem,
            CrmObjectSelectComponent: CrmObjectSelectComponent
          })
        }), /*#__PURE__*/_jsx(UIWizardStep, {
          children: /*#__PURE__*/_jsx(TimelineItemDiagnosisStep, {
            flowId: flowId,
            objectId: objectId,
            objectTypeId: objectTypeId,
            timelineItem: selectedTimelineItem
          })
        })]
      })
    })
  });
};
export default NonEnrollmentDiagnosisPanel;